<template>
  <div class="common-font-size">
    <el-row class="navcon-title">
      <img class="showimg" :src="collapsed?imgsq:imgshow" @click="toggle(collapsed)">
      <el-col :span="24" style="text-align: right;">
        <div style="position: relative;">
          <i class="el-icon-bell"></i>
          <span class="end-time">到期时间：{{endTime}}</span>
          <i class="el-icon-s-custom left-large-margin"></i>
          <span class="right-large-margin user-name">
            <el-popover
              placement="top-start"
              width="235"
              trigger="click"
              >
               <div class="logout-card">
                  <div class="el-main">
                    <div class="list-top-margin">{{user.account}}</div>
                    <div v-if="user.role !== '超级管理员'">{{'工厂名称：' + (user.factory && user.factory.factoryName || '')}}</div>
                    <div v-else>超级管理员</div>
                  </div>
                  <el-divider></el-divider>
                  <div class="logout-button" @click="exit()">退出登录</div>
                </div>

              <span id="the_div2" slot="reference">{{user.account}}</span>
            </el-popover>
          </span>
          <i class="el-icon-info" style="margin-right:15px;" title="免责声明" @click="showVisible"></i>
        </div>
      </el-col>
    </el-row>

     <el-dialog
      title="免责声明"
      :visible.sync="visible"
      width="660px"
      :show-close="true"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      >
      <div style="margin-top:-35px;">

        <h2 style="text-align:center;">免责声明</h2>
        <p style="text-indent:2em;">
          访问者在从事与本网站相关的所有行为(包括但不限于访问浏览、利用、转载、宣传介绍)时，必须以善意且谨慎的态度行事;访问者不得故意或者过失的损害或者弱化本网站的各类合法权利与利益，不得利用本网站以任何方式直接或者间接的从事违反中国法律、国际公约以及社会公德的行为，且访问者应当恪守下述承诺：
        </p>
        <p style="text-indent:2em;">
          1、传输和利用信息符合中国法律、国际公约的规定、符合公序良俗;
        </p>
        <p style="text-indent:2em;">
          2、不将本网站以及与之相关的网络服务用作非法用途以及非正当用途;
        </p>
        <p style="text-indent:2em;">
          3、不干扰和扰乱本网站以及与之相关的网络服务;
        </p>
        <p style="text-indent:2em;">
          4、遵守与本网站以及与之相关的网络服务的协议、规定、程序和惯例等。
        </p>
        <p style="text-indent:2em;">
          5、本软件为学习交流使用，经软件制作者同意可免费使用本软件，任何人不可用于商业用途。
        </p>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import { logout } from '../api/userMG'
export default {
  name: 'navcon',
  data() {
    return {
      collapsed: true,
      imgshow: require('../assets/img/show.png'),
      imgsq: require('../assets/img/sq.png'),
      user: {},
      endTime:'2023-4-20',
      visible:false

    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    this.user = JSON.parse(localStorage.getItem('userdata'));
    this.endTime = this.user.factory.exp;

  },
  mounted(){
    // window.onload = function() {
    //   document.onclick = function(e) {
    //     var ele =  e.target
    //     if(ele.id !== 'the_div' && ele.id !== 'the_div2') {
    //       if(document.getElementById('the_div')){
    //         document.getElementById('the_div').style.display = 'none';
    //       }
    //     }else if(ele.id == 'the_div2'){
    //       document.getElementById('the_div').style.display = 'inline-block';
    //     }
    //   }
    // }
  },
  methods: {
    showVisible(){
      this.visible = true;
    },
    // 退出登录
    exit() {
      this.$confirm('退出登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          setTimeout(() => {
            localStorage.setItem('userdata','');
            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            logout();
            this.$message({
              type: 'success',
              message: '已退出登录!'
            })
          }, 1000)
          // loginout()
          //   .then(res => {
          //     if (res.success) {
          //       //如果请求成功就让他2秒跳转路由
          //       setTimeout(() => {
          //         this.$store.commit('logout', 'false')
          //         this.$router.push({ path: '/login' })
          //         this.$message({
          //           type: 'success',
          //           message: '已退出登录!'
          //         })
          //       }, 1000)
          //     } else {
          //       this.$message.error(res.msg)
          //       this.logining = false
          //       return false
          //     }
          //   })
          //   .catch(err => {
          //     // 获取图形验证码
          //     this.getcode()
          //     this.logining = false
          //     this.$message.error('退出失败，请稍后再试！')
          //   })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 切换显示
    toggle(showtype) {
      this.collapsed = !showtype
      this.$root.Bus.$emit('toggle', this.collapsed)
    },
  }
}
</script>
<style scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
}
/* .submenu {
  float: right;
} */
.buttonimg {
  height: 60px;
  background-color: transparent;
  border: none;
}
.showimg {
  width: 26px;
  height: 26px;
  position: absolute;
  top: 17px;
  left: 17px;
  z-index: 1000;
}
/* .showimg:active {
  border: none;
} */
/* .el-submenu {
  background-color: #fff;
} */
.navcon-title{
  height: 60px;
  line-height: 60px;
  color: #fff;
}
.end-time{
  font-size: 14px;
}
.user-name{
  cursor: pointer;
}
.logout-button{
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgb(255, 0, 0);
  height: 30px;
  cursor: pointer;
}
.el-divider--horizontal{
  margin: 5px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/navcon.vue